import Data1 from "../assets/img/icons/writing.png";
import Data2 from "../assets/img/icons/diagram.png";
import Data3 from "../assets/img/icons/gear.png";

export const DataList = [
    {
        img: Data1
    },
    {
        img: Data2
    },
    {
        img: Data3
    }
]